import { createSlice } from '@reduxjs/toolkit';

// Correctly initialize initialState with type annotation
const initialState = {
  menu: [],
  permanentmenu: [],
  emergencymenu:[]
};

const addTitleSlice = createSlice({
  name: 'campaignMenu',
  initialState,
  reducers: {
    addTitle: (state, action) => {
      state.menu = action.payload;
    },
     addTitlePermanent: (state, action) => {
          state.permanentmenu = action.payload;
        },
        addTitleEmergency: (state, action) => {
          state.emergencymenu = action.payload;
        },
  },
});

export const { addTitle,addTitlePermanent,addTitleEmergency } = addTitleSlice.actions;
export default addTitleSlice.reducer;
